import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-404d5737"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "OkTextarea__name"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "OkTextarea__required" }, "*", -1))
const _hoisted_3 = ["value", "cols", "rows", "disabled", "placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "OkTextarea__error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OkTextarea", { 'OkTextarea--invalid': _ctx.isInvalid, 'OkTextarea--disabled': _ctx.disabled }])
  }, [
    (Boolean(_ctx.name))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.required)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.name) + " ", 1),
                _hoisted_2
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(_toDisplayString(_ctx.name), 1)
              ], 64))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("textarea", {
      ref: "textarea",
      class: _normalizeClass(["OkTextarea__control", { autoheight: _ctx.autoheight }]),
      style: _normalizeStyle({ height: _ctx.autoheight ? _ctx.autoheight : 'auto' }),
      value: _ctx.value,
      cols: _ctx.cols,
      rows: _ctx.rows,
      disabled: _ctx.disabled,
      placeholder: _ctx.placeholder,
      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitInput && _ctx.emitInput(...args))),
      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitChange && _ctx.emitChange(...args)))
    }, null, 46, _hoisted_3),
    (Boolean(_ctx.validationErrors.length))
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.getValidationMessage(_ctx.validationErrors)), 1))
      : _createCommentVNode("", true)
  ], 2))
}